import React, { FC } from 'react'
import { clearHtml } from '../../../../lib/utils'
import Image from '../../../common/Image/Image'
import { IProductQuote } from '../../../types'
import LearnMoreSvg from '../../../../public/static/icons/learn-more.svg'
import styles from './ProductQuote.module.scss'

const ProductQuote: FC<{ quote: IProductQuote }> = ({ quote }) => {
  if (!quote) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <figure className={styles.cover}>
        <Image
          src={quote?.img}
          width={555}
          height={600}
          objectFit="cover"
          layout="responsive"
        />
      </figure>

      <div className={styles.quote__wrapper}>
        <blockquote
          className={styles.quote}
          dangerouslySetInnerHTML={{
            __html: clearHtml(quote?.quote),
          }}
        />

        <div className={styles.author__wrapper}>
          <figure className={styles.author__img}>
            <Image
              src={quote?.author.img}
              width={60}
              height={60}
              objectFit="cover"
              layout="fixed"
            />
          </figure>
          <div
            className={styles.author__description}
            dangerouslySetInnerHTML={{
              __html: clearHtml(quote?.author.description),
            }}
          />
          {quote?.source && (
            <a
              href={quote?.source}
              target="_blank"
              rel="noreferrer"
              className={styles.author__source}
            >
              <LearnMoreSvg />
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProductQuote
